module.exports = __webpack_public_path__ + "assets/blue-up-arrow.2ab714cdbdc478d11e88d604db1c5081.svg";